import { ShieldCheck, Users, Gauge } from "lucide-react";
import { UserAccess } from "@/components/UserAccess";
import { AiUsageMeter } from "@/components/AiUsageMeter";

// Owner-only admin hub: user access requests + Universal Key AI usage.
export const AdminPage = ({ onChanged }) => (
  <div className="space-y-6" data-testid="admin-page">
    <div className="flex items-center gap-3">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#9B2226]/20 text-[#E0575B]">
        <ShieldCheck className="h-5 w-5" />
      </div>
      <div>
        <h2 className="font-display text-xl font-800 tracking-tight text-zinc-100">Admin</h2>
        <p className="text-sm text-zinc-400">Owner-only controls for access and AI usage.</p>
      </div>
    </div>

    <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-5" data-testid="admin-users">
      <h3 className="mb-1 flex items-center gap-2 text-sm font-700 text-zinc-100"><Users className="h-4 w-4 text-[#E0575B]" /> Users / Access</h3>
      <p className="mb-3 text-xs text-zinc-400">Approve or deny people who request access. Each person gets their own private data — no one can see anyone else's.</p>
      <UserAccess onChanged={onChanged} />
    </section>

    <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-5" data-testid="admin-ai-usage">
      <h3 className="mb-1 flex items-center gap-2 text-sm font-700 text-zinc-100"><Gauge className="h-4 w-4 text-[#E0575B]" /> AI Usage</h3>
      <p className="mb-3 text-xs text-zinc-400">Your Universal Key spend — exact tokens per read, plus cost when your provider reports it.</p>
      <AiUsageMeter />
    </section>
  </div>
);
